import { createSelector } from "reselect";

const getSideBar = (state) => state.sideBar.sidebarShow;

export const getSideBarSelector = createSelector(
  getSideBar,
  (sidebar) => sidebar
);
